import type { TowerDesign } from "@/game/towerSpec";
import type { Material } from "@/physics/model";
const A572_65: Material = { name: "A572 Gr65", E: 200e9, Fy: 448e6, rho: 7850 };
/** AU DA planning drawing, 30 m monopole. Pole ODs not tabulated -> base ~1.0m/top ~0.4m ESTIMATED. AS/NZS 1170.2 design. */
export const design: TowerDesign = {
  id: "monopole-wagga-30m",
  name: "Monopole (Wagga 30 m, AU)",
  description: "Real 30 m monopole, Wagga Wagga NSW Australia (DA drawing).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "monopole",
    height: 30,
    stack: { faces: 12, panels: 10, baseRadius: 0.5, topRadius: 0.2,
      legSection: "legXXL", braceSection: "braceHeavy", legMaterial: A572_65, braceMaterial: A572_65, bracing: "X" },
    shell: { baseDiameter: 1.0, topDiameter: 0.4 },
    foundation: { soil: "dense-sand",
      base: { type: "pier", width: 2.2, diameter: 2.2, depth: 6.0, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 12, bolt: "b1_75", grade: "f1554_105", boltCircleDia: 1.2, embedment: 0.45, edgeDistance: 0.3, platePlanArea: 1.8, plateThickness: 0.05, plateGrade: "a36rod", fc: 30e6 } },
  },
};
